<div style="position: relative; width: 100%; height: 100%;">
    <iframe [src]="safe_url" style="position: absolute; width: 100%; height: 100%;"></iframe>
</div>
